import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100/70">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 p-8 md:p-10 rounded-3xl bg-background-50 border border-background-200/70">
          <div className="w-40 h-40 md:w-48 md:h-48 shrink-0 rounded-2xl overflow-hidden bg-gradient-to-br from-accent-400 to-primary-600 flex items-center justify-center">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20modern%20mobile%20app%20icon%20design%20abstract%20with%20coral%20and%20gold%20gradient%2C%20clean%20rounded%20square%20shape%2C%20entertainment%20news%20app%20style%2C%20flat%20elegant%20design%20aesthetic&width=480&height=480&seq=app-icon-51cg&orientation=squarish"
              alt="51cg移动客户端"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              移动吃瓜
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              {appInfo.desc}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mt-5">
              {appInfo.features.map((f, idx) => (
                <span
                  key={idx}
                  className="text-xs px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap"
                >
                  {f}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6">
              <button className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-foreground-900 text-white text-sm font-medium hover:bg-foreground-800 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                <i className="ri-apple-line text-base"></i>
                App Store
              </button>
              <button className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-foreground-900 text-white text-sm font-medium hover:bg-foreground-800 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                <i className="ri-android-line text-base"></i>
                Android 下载
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}